import axios from 'axios'
const { VUE_APP_API_URL, VUE_APP_ETRAILS_API } = process.env

const sendEtrail = async (data) => {
  try {
    const res = await axios.post(`${VUE_APP_ETRAILS_API}/etrails`, data)
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    // Surface whatever message the API sent (e.g. a client-data
    // verification failure) instead of swallowing it entirely — previously
    // every failure here looked identical to the caller, with no way to
    // tell "we couldn't verify that email" apart from a network error.
    const message =
      (err.response &&
        err.response.data &&
        (err.response.data.error || err.response.data.message)) ||
      null
    return { error: true, message }
  }
}

// Post-travel surveys are deliberately kept on apiserver's etrail chain rather
// than TF-etrails-api: apiserver renders the per-section internal email and
// saves the survey to posttravelfeedbacks (see apiserver docs/pt-survey.md).
const sendPtSurvey = async (data) => {
  try {
    const res = await axios.post(`${VUE_APP_API_URL}/api/etrail/v2`, data)
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const isOfficeOpen = async () => {
  try {
    const res = await axios.post(`${VUE_APP_API_URL}/api/officeOpen`, {})
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const getField14 = async (custNo) => {
  try {
    const res = await axios.post(
      `${VUE_APP_API_URL}/api/superfacts/cli-status`,
      { custNo },
    )
    if (res && res.data) {
      return res.data.field14
    }
  } catch (err) {
    return null
  }
}

const checkPtSurveyCompleted = async (bookingNumber, passengerId) => {
  try {
    const res = await axios.get(`${VUE_APP_API_URL}/api/pt-survey/check`, {
      params: { bookingNumber, passengerId },
    })
    if (res && res.data) {
      return !!res.data.completed
    }
    return false
  } catch (err) {
    return false
  }
}

// The BE decides which sections (tours, Communications & Information, ...) and
// questions a booking gets. The client only passes the raw itinerary lines on.
// Returns null on failure so the survey can show its load-error state.
const getSurveyDefinition = async (bookingNumber, itineraryItems) => {
  try {
    const res = await axios.post(`${VUE_APP_API_URL}/api/pt-survey/definition`, {
      bookingNumber,
      platform: 'desktop',
      itineraryItems,
    })
    if (res && res.data && Array.isArray(res.data.sections)) {
      return res.data
    }
    return null
  } catch (err) {
    return null
  }
}

export {
  sendEtrail,
  sendPtSurvey,
  isOfficeOpen,
  getField14,
  checkPtSurveyCompleted,
  getSurveyDefinition,
}
